<template>
  <div class="container alturaMinima">
        <embed src="/assets/files/ppdp.pdf" type="application/pdf" width="100%" height="700px" />
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: 'Política de protección de datos personales - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Política de protección de datos personales - QualityCare',
        content: 'QualityCare ofrece una política de protección de datos personales para que los usuarios puedan conocer cómo se manejan sus datos',
      },
    ],
  },
  name: "Instalaciones",
  data() {
    return {};
  },  
};
</script>

<style lang="scss" scoped>

* {
  font-size: 1.3rem;
}

.container {
  background-color: #ffffff;
  padding-inline: 30px;
}

</style>
